export default [
"1 年 ~ 5 年",
"6 年 ~ 10 年",
"10 年以上",
]


// WEBPACK FOOTER //
// ./src/Data/yearOfLiving.js